import Vue from 'vue'
import Router from 'vue-router'
import firebase from 'firebase'

import Login from './views/Login/Login'
import Dashboard from './views/Dashboard/Dashboard'
import CreateShop from './views/create/createShop'

import Setting from './views/Setting/CompanySetting'

import ReviewList from './views/Review/ReviewList'
import ReviewListContent from './views/Review/ReviewListContent'
import ReviewListContentUnit from './views/Review/ReviewListContentUnit'

import OnlineCourseList from './views/OnlineCourse/OnlineCourseList'
import OnlineCourseListContent from './views/OnlineCourse/OnlineCourseListContent'
import OnlineCourseListContentUnit from './views/OnlineCourse/OnlineCourseListContentUnit'
import CenterCourseList from './views/CenterCourse/OnlineCourseList'
import CenterCourseListContent from './views/CenterCourse/OnlineCourseListContent'
import CenterCourseListContentUnit from './views/CenterCourse/OnlineCourseListContentUnit'
// Lazy import
// component: () => import(/* webpackChunkName: "about" */ './views/About.vue')

Vue.use(Router)

const router = new Router({
  mode: 'history',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '*',
      redirect: '/dashboard'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/create',
      name: 'CreateShop',
      component: CreateShop,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/dashboard',
      redirect: '/dashboard/online-course',
      name: 'Dashboard',
      component: Dashboard,
      meta: {
        requiresAuth: true
      },
      children: [
        {
          path: '/dashboard/setting',
          name: 'Setting',
          component: Setting
        },
        {
          path: '/dashboard/review',
          name: 'ReviewList',
          component: ReviewList
        },
        {
          path: '/dashboard/review/:id',
          name: 'ReviewListContent',
          component: ReviewListContent
        },
        {
          path: '/dashboard/review/:id/:id',
          name: 'ReviewListContentUnit',
          component: ReviewListContentUnit
        },
        {
          path: '/dashboard/online-course',
          name: 'OnlineCourseList',
          component: OnlineCourseList
        },
        {
          path: '/dashboard/online-course/:id',
          name: 'OnlineCourseList',
          component: OnlineCourseListContent
        },
        {
          path: '/dashboard/online-course/:id/:id',
          name: 'OnlineCourseList',
          component: OnlineCourseListContentUnit
        },
        {
          path: '/dashboard/center-course',
          name: 'CenterCourseList',
          component: CenterCourseList
        },
        {
          path: '/dashboard/center-course/:id',
          name: 'CenterCourseList',
          component: CenterCourseListContent
        },
        {
          path: '/dashboard/center-course/:id/:id',
          name: 'CenterCourseList',
          component: CenterCourseListContentUnit
        }
      ]
    }
  ]
})

export default router

router.beforeEach((to, from, next) => {
  const requiresAuth = to.matched.some(x => x.meta.requiresAuth)
  const currentUser = firebase.auth().currentUser

  if (requiresAuth && !currentUser) {
    next('/login')
  } else if (requiresAuth && currentUser) {
    next()
  } else {
    next()
  }
})
